"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgLockOpenOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M22 12V7.09a4.59 4.59 0 00-1-3.35C20 2.6 18.3 2 16 2s-4 .6-5 1.74a4.6 4.6 0 00-1 3.35V8h2v-.91c0-1.33.21-1.68.53-2.06.56-.66 1.79-1 3.47-1s2.89.37 3.46 1c.32.39.54.75.54 2.06V12H6v15.13l.44.3A18.14 18.14 0 0016 30a18.14 18.14 0 009.56-2.57l.44-.3V12zm2 14a16.81 16.81 0 01-8 2 16.92 16.92 0 01-8-2V14h16z" }),
        React.createElement("path", { d: "M15 20.72V24h2v-3.28A2 2 0 0018 19a2 2 0 10-3 1.72z" })));
}
exports.default = SvgLockOpenOutline;
//# sourceMappingURL=LockOpenOutline.js.map